import React, { FC } from 'react';
//@ts-ignore
import Outside from 'react-click-outside';

interface ClickOutSideProps {
    className?: string;
    onClickOutside: (event: any) => void;
}

const ClickOutside: FC<ClickOutSideProps> = (props) => {
    return <Outside {...props} />;
};

export { ClickOutside };
